/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { ButtonGroup, Card, Col, InputGroup, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Button, Input, Table } from "../../../components";
import { useAppDispatch, useAppSelector } from "../../../redux/Hooks/Hook";
import {
  AllCoachingBookingList,
  setCoachingColumn,
} from "../../../redux/Slice/CoachingBooking/CoachingBookingListSlice";
import DatePicker from "react-multi-date-picker";
import BootstrapSelect from "react-bootstrap-select-dropdown";
import InputIcon from "react-multi-date-picker/components/input_icon";
import { CoachingFilterModel } from "./CoachingFilterModel";
import { format } from "date-fns";
import { toast } from "react-toastify";
import { DownloadCoachBookingReport } from "../../../utilities/api/coachingBooking";
import { DownloadModal } from "../CourtsBooking/DownloadModal";

const ListOfCoachingSessionBooking = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const {
    AllCoachBookingData = [],
    currentPage,
    rowsPerPage,
    totalPage,
    totalRows,
    coachingColumns,
    errorMessage
  } = useAppSelector((state) => state?.coachBooking);
  const { SelectedFacility = "" } = useAppSelector(
    (state) => state.facilityList
  );
  const [key, setKey] = useState("");
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [show, setShow] = useState(false);
  const [sportName, setSportName] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");
  const [coachName, setCoachName] = useState("");
  const [sorting, setSorting] = useState({ column: "", order: "" });
  const [downloadModalOpen, setDownloadModalOpen] = useState(false);
  const [isMounted, setIsMounted] = useState(false);

  if (errorMessage) {
    toast.error(errorMessage.message)
  }

  const ALL_COLUMNS = [
    {
      value: "Customer Name",
      labelKey: "name",
    },
    {
      value: "Contact Number",
      labelKey: "contact",
    },
    {
      value: "Session Name",
      labelKey: "sessionName",
    },
    {
      value: "Sport Name",
      labelKey: "sportName",
    },
    {
      value: "Session Per Week",
      labelKey: "noOfDays",
    },
    {
      value: "Enrolled Sessions",
      labelKey: "noOfSessionToAttend",
    },
    {
      value: "Remaining Session",
      labelKey: "remainingSessions",
    },

    {
      value: "Start Date",
      labelKey: "startDate",
    },
    {
      value: "End Date",
      labelKey: "endDate",
    },
    {
      value: "Amount",
      labelKey: "totalAmount",
    },
    {
      value: "Payment Status",
      labelKey: "paymentStatus",
    },
    {
      value: "Session Booking Status",
      labelKey: "bookingStatus",
    },
    {
      value: "Coach Name",
      labelKey: "coachName",
    },
  ];

  const orderColComing = ["sportName", "startDate", "endDate", "paymentStatus"];

  const orderColSend = ["sport", "startDate", "endDate", "paymentStatus"];

  const orderByColumn = (column: string) => {
    if (orderColComing.includes(column))
      return orderColSend[orderColComing.indexOf(column)];
    else return "";
  };
  const orderCol = orderByColumn(sorting.column);

  useEffect(() => {
    if (isMounted) {
      if (
        !key &&
        !fromDate &&
        !toDate &&
        !paymentStatus &&
        !coachName &&
        !sportName
      ) {
        dispatch(AllCoachingBookingList({ page: "1" }));
      }
    } else {
      setIsMounted(true);
    }
  }, [key, fromDate, toDate, sportName, coachName, paymentStatus]);

  useEffect(() => {
    handleSearch();
  }, [sorting, SelectedFacility]);

  const handleAdd = () => {
    navigate("/coaching-session-booking/add-new");
  };

  const NextPage = (page: string) => {
    handleSearch(page);
  };

  const PreviousPage = (page: string) => {
    handleSearch(page);
  };

  const handleCoachingBookingInfo = (row: any) => {
    navigate(`/coaching-session-booking-detail/${row}`, { state: row });
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleSearch = (page: any = "") => {
    dispatch(
      AllCoachingBookingList({
        page: !page || typeof page === "object" ? "1" : page,
        fromDate: fromDate ? format(fromDate, "yyyy-MM-dd") : "",
        toDate: toDate ? format(toDate, "yyyy-MM-dd") : "",
        keyword: key,
        sportId: sportName,

        status: paymentStatus,
        orderByCol: orderCol,
        orderBy: sorting.order,
        facilityId: SelectedFacility,
      })
    );
  };

  const handleDownload = async () => {
    const result = await DownloadCoachBookingReport({
      page: "1",
      fromDate: fromDate ? format(fromDate, "yyyy-MM-dd") : "",
      toDate: toDate ? format(toDate, "yyyy-MM-dd") : "",
      keyword: key,
      sportId: sportName,

      status: paymentStatus,
      orderByCol: orderCol,
      orderBy: sorting.order,
    });
    if (result.statusCode === 200) {
      setDownloadModalOpen(false);
      const url = result.data.fileUrl;
      const link = document.createElement("a");
      link.href = url;
      document.body.appendChild(link);
      link.click();
      link.parentNode?.removeChild(link);
    } else {
      toast.error(result.response.data.message);
    }
  };

  const handleFromDate = (e: any) => {
    setFromDate(e?.toDate());
  };

  const handleToDate = (e: any) => {
    setToDate(e?.toDate());
  };

  const handleClear = () => {
    setKey("");
    setFromDate(undefined);
    setToDate(undefined);
    setPaymentStatus("");
    setCoachName("");
    setSportName("");
    setSorting({ column: "", order: "" });
  };

  const handleChange = (value: any) => {
    const col = value.selectedValue.map((item: string, index: number) => {
      return {
        Header: item,
        accessor: value.selectedKey[index],
      };
    });
    dispatch(setCoachingColumn(col));
  };

  const handleFilterSubmit = () => {
    handleSearch();
    setShow(false);
  };

  const defaultColumn = [...coachingColumns].map((item) => item.accessor);

  return (
    <>
      <Card>
        <Card.Body className="pb-0">
          <div className="page-title align-items-center d-flex justify-content-between">
            <Card.Title className="mb-0">
              Coaching Session Booking List
            </Card.Title>
            <ButtonGroup>
              <Button
                type="button"
                bname="Filter"
                onClick={handleShow}
                className="btn btn-light me-2 rounded-1 text-dark text-info fitler-img"
                id="filter"
                name="filter"
              ></Button>
              {AllCoachBookingData.length !== 0 && (
                <Button
                  onClick={() => setDownloadModalOpen(true)}
                  type="button"
                  bname="Download Reports"
                  name="download-reports"
                  id="download-reports"
                  className="btn btn-primary rounded-1 me-2"
                ></Button>
              )}
              <Button
                onClick={handleAdd}
                type="button"
                bname="Add Booking"
                name="add-booking"
                id="add-booking"
                className="btn btn-primary px-4 rounded-1 me-2"
              ></Button>
              <BootstrapSelect
                options={ALL_COLUMNS}
                isMultiSelect={true}
                showTick={true}
                defaultOptions={defaultColumn}

                showSearch={true}
                showAction={true}
                placeholder="Select Column "
                className="edit-column"
                selectStyle="btn-primary"
                actionBtnStyle="btn-outline-primary"
                onChange={handleChange}
              />
            </ButtonGroup>
          </div>

          <Row className="row-mb">
            <Col lg={3} style={{ paddingTop: "31px" }}>
              <div className="text-start">
                <InputGroup>
                  <Input
                    type="text"
                    id="search-booking"
                    name="search-booking"
                    className="form-control form-control-sm h-auto"
                    placeholder="Search . . ."
                    value={key}
                    onChange={(e: any) => setKey(e.target.value)}
                  />
                  <Button
                    disabled={key.length < 3}
                    onClick={handleSearch}
                    type="button"
                    bname="Search"
                    name="search-button"
                    id="search-button"
                    className="btn btn-primary btn-sm rounded-1"
                  />
                </InputGroup>
                {!!key && key.length < 3 && (
                  <span className="error-msg">Minimum 3 character required</span>
                )}
              </div>
            </Col>
            <Col lg={4}>
              <label className="form-label me-1"> Start Date : </label>
              <DatePicker
                format="DD-MM-YYYY"
                value={fromDate}
                onChange={handleFromDate}
                render={
                  <InputIcon className="form-control form-control-sm h-auto" />
                }
              />
            </Col>
            <Col lg={4} className="position-relative">
              <InputGroup className="align-items-center">
                <label className="form-label me-1"> End Date : </label>
                <DatePicker
                  format="DD-MM-YYYY"
                  minDate={fromDate}
                  value={toDate}
                  onChange={handleToDate}
                  render={
                    <InputIcon className="border-end-0 form-control form-control-sm h-auto" />
                  }
                />
                <Button
                  onClick={handleSearch}
                  type="button"
                  bname="Go"
                  name="Go-button"
                  id="go-button"
                  className="btn btn-primary btn-sm rounded-1"
                />
              </InputGroup>
              {/* {(fromDate ||
                toDate ||
                key ||
                sportName ||
                coachName ||
                paymentStatus) && (
                  <div
                    onClick={handleClear}
                    className="btn btn-link position-absolute top-0"
                    style={{ cursor: "pointer", left: "90%" }}
                  >
                    Clear
                  </div>
                )} */}
            </Col>
            <Col lg={1} style={{ paddingTop: "31px" }}>
              {(fromDate ||
                toDate ||
                key ||
                sportName ||
                coachName ||
                paymentStatus) && (
                <div
                  onClick={handleClear}
                  className="btn btn-link"
                  style={{ cursor: "pointer", left: "90%" }}
                >
                  Clear
                </div>
              )}
            </Col>
          </Row>
        </Card.Body>
        <div className="table-responsive">
          <Table
            columns={coachingColumns}
            data={AllCoachBookingData}
            currentPage={currentPage}
            rowsPerPage={rowsPerPage}
            totalRows={totalRows}
            totalPage={totalPage}
            NextPage={NextPage}
            PreviousPage={PreviousPage}
            hideEditAction={true}
            HandleShow={handleCoachingBookingInfo}

            hideDeleteAction={true}
            hideGlobalFilter={true}
            show={true}
            isSorting={true}
            sorting={sorting}
            setSorting={setSorting}
            orderColComing={orderColComing}
          />
        </div>
      </Card>
      <CoachingFilterModel
        show={show}
        handleClose={handleClose}
        paidStatus={paymentStatus}
        sportName={sportName}
        coachName={coachName}
        setCoachName={setCoachName}
        setPaymentStatus={setPaymentStatus}
        setSportName={setSportName}
        handleFilterSubmit={handleFilterSubmit}
      />
      <DownloadModal
        downloadModalOpen={downloadModalOpen}
        setDownloadModalOpen={setDownloadModalOpen}
        handleDownload={handleDownload}
      />
    </>
  );
};

export { ListOfCoachingSessionBooking };
